
export default class Media {

    constructor(
        id,
        deviceManualCommandId,
        dateRequested,
        state,
        createdByName,
        createdBy,
        createdOn,
        modifiedOn,
        modifiedBy,
        vehicleRegistrationNumber,
        driverName,
        hardwareId,
        hasBeenViewed,
        organizationName,
        organizationId,
        fleetName,
        fleetId,
        eventId,
        miniatureUri,
        lastActionOn,
        isVisible = true,
    ) {
        this.id = id
        this.deviceManualCommandId = deviceManualCommandId
        this.dateRequested = dateRequested
        this.state = state
        this.createdByName = createdByName
        this.createdBy = createdBy
        this.createdOn = createdOn
        this.modifiedOn = modifiedOn
        this.modifiedBy = modifiedBy
        this.vehicleRegistrationNumber = vehicleRegistrationNumber
        this.driverName = driverName
        this.hardwareId = hardwareId
        this.hasBeenViewed = hasBeenViewed
        this.organizationName = organizationName
        this.organizationId = organizationId
        this.fleetName = fleetName
        this.fleetId = fleetId
        this.eventId = eventId
        this.miniatureUri = miniatureUri
        this.lastActionOn = lastActionOn
        this.isVisible = isVisible
    }

}
